import {makeStyles} from "@material-ui/core/styles";
import images from "../../../../../../../images";
import {checkPseudoStyles} from "../../formElement/RadioCard/styles";

const replaceRadioWithCheckStyles = {
  // replace radio svg with fontawesome check icon
  '& svg': {
    display: 'none',
  },
  '& .MuiIconButton-root .MuiIconButton-label div::before': checkPseudoStyles
};

const useStyles = makeStyles(theme => ({
  questionContainer: {
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  errorContainer: {
    fontFamily: 'Roboto-Bold',
    padding: '0 1rem',
    fontSize: 16,
    margin: '0 1rem',
  },
  item: {
    width: 390,
    height: 340,
    padding: theme.spacing(2),
    margin: theme.spacing(2),
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',

    '&:not(.newDesign)': {
      border: '1px solid #D8DCDF',
      borderRadius: 4,
    },

    '&.newDesign': {
      padding: theme.spacing(3),
      borderRadius: 16,
      boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.10), 0px 1px 3px 1px rgba(0, 0, 0, 0.10)',
      border: '1px solid',
      borderColor: 'transparent',
      '&:hover': {
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 2px 6px 2px rgba(0, 0, 0, 0.10)',
        ...replaceRadioWithCheckStyles
      },
    }
  },
  title: {
    fontSize: 16,
    marginBottom: 16,
    paddingRight: 16
  },
  name: {
    position: 'relative',
  },
  selected: {
    fontFamily: 'Roboto-Bold',
    '&:not(.newDesign)': {
      border: 'none',
      boxShadow: '0px 3px 15px #00000033',
      '& $name::after': {
        position: 'absolute',
        content: '""',
        width: 30,
        height: 30,
        top: '50%',
        left: '100%',
        transform: 'translate(15px, -15px)',
        backgroundImage: `url(${images.select_list_icon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain'
      }
    },
    '&.newDesign': {
      borderColor: theme.palette.primary.main,
      ...replaceRadioWithCheckStyles
    }
  },
  chartImage: {
    width: '100%',
    flex: 1,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center'
  },
}));

export default useStyles;